import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";

export default function PlaybookDetail() {
  const { slug } = useParams();
  const [p, setP] = useState(null);
  const [missing, setMissing] = useState(false);
  useEffect(() => { api.get(`/playbooks/${slug}`).then((r) => setP(r.data)).catch(() => setMissing(true)); }, [slug]);

  if (missing) return <div className="max-w-6xl mx-auto px-6 pt-20 font-serif-d text-3xl" data-testid="playbook-not-found">Playbook not found.</div>;
  if (!p) return null;
  return (
    <div className="max-w-6xl mx-auto px-6 pt-14" data-testid="playbook-detail-page">
      <Link to="/playbooks" className="inline-flex items-center gap-2 text-sm text-[var(--ink-2)] hover:text-[var(--ink)] mb-10" data-testid="back-to-playbooks"><ArrowLeft className="w-4 h-4" /> All use cases</Link>
      <div className="grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-5 rise">
          <div className="flex gap-4 font-mono-d text-[11px] tracking-widest uppercase text-[var(--ink-3)] mb-6"><span>{p.number}</span><span>/</span><span>{p.category}</span></div>
          <h1 className="font-serif-d text-5xl sm:text-6xl tracking-tight mb-6" data-testid="playbook-name">{p.name}</h1>
          <p className="text-lg text-[var(--ink-2)] leading-relaxed mb-4">{p.summary}</p>
          <p className="text-sm text-[var(--ink-3)] mb-10"><span className="eyebrow mr-2">Best for</span>{p.audience}</p>
          <Link to="/new" className="btn-ink px-7 py-3.5 text-sm font-medium inline-block" data-testid="playbook-start-btn">Upload a document</Link>
        </div>
        <div className="lg:col-span-7">
          <p className="eyebrow mb-4">What we check</p>
          <ol className="border-t border-[var(--ink)]" data-testid="playbook-checks">
            {p.checks.map((c, i) => (
              <li key={c} className="flex gap-6 py-5 border-b border-[var(--rule)] rise" style={{ animationDelay: `${i * 50}ms` }}>
                <span className="font-mono-d text-xs text-[var(--ink-3)] pt-1.5">{String(i + 1).padStart(2, "0")}</span>
                <span className="font-serif-d text-2xl">{c}</span>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </div>
  );
}
